var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAvalancheBc = function SvgAvalancheBc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1228_77367",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 94,
    height: 94
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H94V94H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1228_77367)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73436 86.288H24.8674C28.4304 86.288 30.2119 86.288 31.8018 85.8502C33.545 85.3366 35.1349 84.4237 36.4567 83.1684C37.6709 82.0201 38.5468 80.4982 40.2754 77.4949L40.3261 77.4068L59.9532 42.9628C61.6964 39.9391 62.5584 38.4177 62.9416 36.8203C63.3629 35.0898 63.3629 33.2641 62.9416 31.5336C62.5613 29.9481 61.6904 28.4375 59.9729 25.4585L59.9341 25.3911L52.2526 12.0791C50.6627 9.30263 49.8582 7.91434 48.8429 7.40093C47.751 6.84943 46.4484 6.84943 45.3566 7.40093C44.3413 7.91434 43.5367 9.30263 41.9468 12.0791L4.58139 77.4639C3.01067 80.2022 2.22525 81.5715 2.28273 82.6935C2.35932 83.9101 2.99155 85.0141 4.02587 85.679C4.98372 86.288 6.55444 86.288 9.73436 86.288ZM63.0831 86.288H84.7676C87.9663 86.288 89.5756 86.288 90.5339 85.6603C91.5673 84.9954 92.2195 83.8729 92.277 82.6559C92.3325 81.5729 91.5661 80.2596 90.0665 77.6897C90.0125 77.5972 89.9576 77.503 89.9017 77.4072L79.04 58.9607C78.9967 58.8879 78.9539 58.8161 78.9117 58.7453C77.3883 56.1881 76.6186 54.8962 75.6302 54.3965C74.5382 53.845 73.2549 53.845 72.1629 54.3965C71.1671 54.9101 70.3624 56.2603 68.7719 58.9797L57.9494 77.4262L57.9122 77.49C56.3279 80.2049 55.5362 81.5616 55.5932 82.675C55.6698 83.8915 56.3019 85.0141 57.3364 85.6801C58.275 86.288 59.884 86.288 63.0831 86.288Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
};

export { SvgAvalancheBc as ReactComponent };
export default __webpack_public_path__ + "630c9987f363a7698d2f6e38fd57b817.svg";